export default function menuOpen() {
    document.addEventListener('DOMContentLoaded', () => {
        const menuButton = document.getElementById('menuToggle');
        const navBar = document.getElementById('menuLinks');

        menuButton.addEventListener('click', () => {
            navBar.classList.toggle('hidden');
        });
    });
}
